module.exports = __webpack_public_path__ + "static/media/test16_4.1e994521.png";